export const formatNumber = (
  amount: number,
  fractionDigits?: number
): string => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: fractionDigits ?? 2,
    maximumFractionDigits: fractionDigits ?? 2,
  }).format(amount);
};
